import { DATEFORMAT_FULL, DATEFORMAT_SHORT } from '@/defs/date'
import { type RecType } from '@/defs/rec'
import { useCardsRec } from '@/hooks/useCardsRec'
import { recentDate } from '@/utils/commonUtil'
import { formatDate } from '@/utils/formatUtil'
import { getRecName } from '@/utils/recUtil'

import { StatCommonBox } from '../../StatCommon/StatCommonBox/StatCommonBox'
import { StatCommonFigure } from '../../StatCommon/StatCommonFigure/StatCommonFigure'

type Props = {
  isInView?: boolean
  rec: RecType
}

export const StatRecSpoilDate = ({ isInView = true, rec }: Props) => {
  const { card, cardPartner, loading } = useCardsRec({ enabled: isInView, rec })
  const fullName = getRecName(rec)

  const date = recentDate(card?.spoiledAt, cardPartner?.spoiledAt)

  const tooltip = date && (
    <>
      <h2>Spoil Date</h2>
      <p>
        <strong>Spoil date</strong> is the date the first printing of a card was first revealed publicly.{' '}
        <strong>{fullName}</strong> was spoiled on <strong>{formatDate(date, DATEFORMAT_FULL)}</strong>.
      </p>
    </>
  )

  return (
    <StatCommonBox isBlank={!isInView} isInView={isInView} label='Spoiled' loading={loading} popover={tooltip}>
      {date && <StatCommonFigure size='sm'>{formatDate(date, DATEFORMAT_SHORT)}</StatCommonFigure>}
    </StatCommonBox>
  )
}
